import gql from 'graphql-tag';

export class ResourceStatisticsFragments {
  static listFragment = gql`
    fragment resourceListStatisticsFragment on ResourceStatistics {
      usedCount
      lastUsed
    }
  `;

  static detailsFragment = gql`
    fragment resourceStatisticsFragment on ResourceStatistics {
      usedCount
      sentCount
      signedCount
      recalledCount
      rejectedCount
    }
  `;
}
